<div class="container-fluid">
  <div class="row mx-0 my-3 mx-md-1">
    <div class="col-12">
      <h6 class="font-weight-bold text-secondary mb-3">Mensajes enviados</h6>
    </div>
    <div class="col-12 col-md-5">
      <div class="row justify-content-between align-items-baseline">
        <div class="col-8">
          <form class="mb-3" [formGroup]="filtro">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Buscar"
                formControlName="buscar_por"
              />
              <div class="input-group-append">
                <button class="btn icon-inside p-0" type="button" (click)="paginador(null)">
                  <mat-icon class="align-bottom"> search </mat-icon>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-3">
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </div>
      </div>
      <div class="p-3">
        <form [formGroup]="filtroOrder">
          <div id="filtros" [ngbCollapse]="isCollapsed" class="row">
            
              <div class="col-6">
                <div class="row">
                  <strong>Filtrar por:</strong>
                </div>
                <div class="row">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="leidos" id="no_leidos" formControlName="no_leidos" (change)="filterChanges(2)">
                    <label class="form-check-label" for="no_leidos">
                      Todos
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" name="leidos" id="leidos" formControlName="leidos"  (change)="filterChanges(1)">
                    <label class="form-check-label" for="leidos">
                      No leídos
                    </label>
                  </div>
                </div>
                
              </div>
              <div class="col-6">
                <div class="row">
                  <strong>Organizar por:</strong>
                </div>
                <div class="row">
                  <div class="form-check">
                    <input type="button" name="fecha" id="fecha" (click)="aumentarPorTipo(1)" class="order-button"
                      [ngClass]="{'asc': tipo_ordenamiento_fecha === 1, 'desc' : tipo_ordenamiento_fecha === 2,'none' : tipo_ordenamiento_fecha === 3 }">
                    <label class="form-check-label ml-2" for="fecha">
                      Fecha
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="form-check">
                    <input type="button" name="para" id="para" (click)="aumentarPorTipo(2)" class="order-button"
                      [ngClass]="{'asc': tipo_ordenamiento_para === 1, 'desc' : tipo_ordenamiento_para === 2,'none' : tipo_ordenamiento_para === 3 }">
                    <label class="form-check-label ml-2" for="para">
                      Para
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="form-check">
                    <input type="button" name="asunto" id="asunto" (click)="aumentarPorTipo(3)" class="order-button"
                      [ngClass]="{'asc': tipo_ordenamiento_asunto === 1, 'desc' : tipo_ordenamiento_asunto === 2,'none' : tipo_ordenamiento_asunto === 3 }">
                    <label class="form-check-label ml-2" for="asunto">
                      Asunto
                    </label>
                  </div>
                </div>
              </div>
            
          </div>
        </form>
      </div>
      <mat-card class="mb-3 p-0">
        <mat-selection-list [multiple]="false" *ngIf="listado && listado.length > 0; else sinResultados">
          <mat-list-option
            *ngFor="let item of listado"
            [value]="item"
            (click)="setMensaje(item)"
            class="h-100 mb-3"
          >
            <div class="row align-items-center">
              <div class="col-12 col-lg-8">
                <p class="m-0 fs">{{ item.asunto }}</p>
                <small class="fs">{{ item.nombre_receptor }}</small>
              </div>
              <div class="col-12 col-lg-4">
                <p class="m-0 fs">
                  {{ item.fecha_creacion | date: "longDate" }}
                </p>
              </div>
            </div>
          </mat-list-option>
        </mat-selection-list>
        <ng-template #sinResultados>
          <p class="p-1">
            No se encontraron resultados
          </p>
        </ng-template>
      </mat-card>
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        (page)="pageEvent = $event; paginador(pageEvent)"
      >
      </mat-paginator>
    </div>
    <div class="col-12 col-md-7" *ngIf="mensaje; else sinSeleccion">
      <mat-card class="example-card">
        <mat-card-header>
          <mat-card-subtitle
            >Fecha:
            {{
              mensaje.fecha_creacion | date: "EEEE, MMMM d, y, h:mm a"
            }}</mat-card-subtitle
          >
          <mat-card-subtitle
            >De: {{ mensaje.usuario_creacion }}</mat-card-subtitle
          >
          <mat-card-subtitle
            >Para: {{ mensaje.nombre_receptor }}</mat-card-subtitle
          >
          <mat-card-subtitle>Asunto: {{ mensaje.asunto }}</mat-card-subtitle>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="mt-3">
          <div [innerHtml]="mensaje.cuerpo"></div>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-template #sinSeleccion>
      <div class="col-12 col-md-7 text-center align-self-center">
        Seleccione un mensaje para visualizarlo aqui
      </div>
    </ng-template>
  </div>
</div>
